import type React from 'react';

interface SlideOutCommonLoaderProps {
  label: string;
  loaderClass: string;
  isLoading: boolean;
  children: React.ReactNode;
  shouldShow: unknown;
  columnClass?: string;
  showLoader?: boolean;
}

const SlideOutCommonLoader: React.FC<SlideOutCommonLoaderProps> = ({
  label, loaderClass, isLoading, children, shouldShow, columnClass, showLoader,
}) => {
  // If the component shouldn't be shown at all, return null
  if (!shouldShow && !isLoading && !showLoader) {
    return null;
  }

  let content: React.ReactNode;

  if (isLoading && showLoader) {
    content = <div className={loaderClass} />;
  } else if (shouldShow) {
    // After loading, show children if shouldShow is true
    content = children;
  } else {
    // If shouldShow is false, render nothing
    return null;
  }

  return (
    <div className={`job-content-col ${columnClass || ''}`}>
      <div className="job-content-label">
        {label}
      </div>
      <div className="job-content-data">
        {content}
      </div>
    </div>
  );
};

export default SlideOutCommonLoader;
